module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/check.c212d8a8.svg";